import { notification } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Map } from './map';
import { OverviewTable } from './overview';
import { TotalUsersDiagram } from './users-diagram-overview';
import { Subscribers } from './subscribers';

export function StatisticsGermanyRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<img src='https://filer.boblberg.dk/assets/img/flags/de.png' alt='DE flag' className='flag' />
			<OverviewTable country={3} />
			<TotalUsersDiagram country={3} yAxisMax={125} yAxisStepSize={25} />
			<Map country={3} />
			{/* <Subscribers country={3} /> */}
		</Container>
	);
}

const Container = styled.main`
	background-color: #1a202c;

	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto repeat(2, 1fr) 2fr;
	grid-template-areas:
		'overview'
		'diagram'
		/* 'subscribers' */
		'map';

	@media (min-width: 1024px) {
		grid-template-columns: 2fr 2fr 1fr;
		grid-template-rows: auto 1fr;
		grid-template-areas:
			'overview overview overview'
			'diagram map .';
	}

	.overview-table {
		grid-area: overview;
	}

	.diagram-container {
		grid-area: diagram;
	}

	.map-dk {
		grid-area: map;
	}

	.subscribers {
		grid-area: subscribers;
	}

	.flag {
		position: absolute;
		top: 10px; 
		left: 10px; 
		width: 50px;
	}
`;
